<template>
    <div style="padding-bottom: 40px">
        <M3Warn v-if="data && data.m3_project && data.m3_project.duplicate_sections && data.m3_project.duplicate_sections.includes('financial_request')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(data.m3_project.duplicate_company_id)"></M3Warn>
        <CFTitle title="14. Metodologie"></CFTitle>
        <validation-observer #default="{ invalid }" ref="metodologie">
            <span class="display-none">{{ invalid }}</span>
            <M3Warn type="yellow" text="Vor fi descrise/detaliate:<br>-	managementul proiectului: organizaţiile implicate, echipa de proiect, rolul managerului de proiect, repartizarea atribuţiilor, rolurile persoanelor implicate etc."></M3Warn>
            <div>
                <p class="subtitle">Managementul proiectului</p>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.manager" :read-only="completed" :limit="3000"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <div style="margin-top: 20px">
                <p class="subtitle">Rolul managerului de proiect</p>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.rol" :read-only="completed" :limit="3000"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <div style="margin-top: 20px">
                <p class="subtitle">Echipa de proiect</p>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.echipa" :read-only="completed" :limit="3000"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
        </validation-observer>
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            style="margin-bottom: -40px;"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import CFTextarea from "./CFTextarea";
    import { BFormCheckbox } from "bootstrap-vue";
    import M3Warn from "../M3Warn";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        name: "CFMetodologie",
        components: {
            CFTextarea,
            BFormCheckbox,
            CFTitle,
            M3Warn,
            ValidationProvider,
            ValidationObserver
        },
        props:{
            m3GrantApplication: {
                type: Object,
                default: null
            },
            data: null
        },
        data() {
            return {
                form: {
                    manager: '',
                    rol: '',
                    echipa: ''
                },
                completed: null,
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            isCompleted() {
                return this.$store.getters['finantare/progress'].includes('Metodologie');
            },
        },
        watch: {
            isCompleted: {
                handler() {
                    this.completed = this.isCompleted;
                },
                deep: true,
                immediate: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.metodologie){
                        this.form.manager= this.m3GrantApplication.metodologie.manager;
                        this.form.rol= this.m3GrantApplication.metodologie.rol;
                        this.form.echipa= this.m3GrantApplication.metodologie.echipa;
                    }
                },
                deep: true
            },
        },
        mounted() {
            if(this.m3GrantApplication && this.m3GrantApplication.metodologie){
                this.form.manager= this.m3GrantApplication.metodologie.manager;
                this.form.rol= this.m3GrantApplication.metodologie.rol;
                this.form.echipa= this.m3GrantApplication.metodologie.echipa;

            } else{
                this.form.manager = 'Managementul proiectului va fi asigurat pe tot parcursul activitatilor. Va fi urmarit modul de realizare a achizitiilor si, mai ales, realizarea unui cash‐flow pe termen mediu care sa asigure finantarea constanta a proiectului, fara a provoca intreruperea implementarii acestuia, in contextul fluctuatiilor factorilor externi proiectului.\n' +
                    'Termenele de realizare tin cont de durata de obtinere a rezultatelor si de resursele puse la dispozitie prin proiect. Sunt prevazute masuri adecvate de monitorizare in raport cu complexitatea acestuia, pentru a se asigura atingerea rezultatelor vizate. \n' +
                    'Solicitantul isi asuma respectarea masurilor minime de informare si publicitate.\n'
                this.form.rol = 'Acesta va presuspune coordonarea tuturor activitatilor in scopul indeplinirii obiectivelor proiectului. In acest sens, se va avea in vedere elaborarea cererilor de prefinantare, rambursare, plata si a raportarilor mentionate in contractul de finantare, monitorizarea obiectivelor, supervizarea procedurilor de lucru, adoptarea unor eventuale masuri preventive/corective.'
                this.form.echipa = 'Solicitantul se asigura de respectarea tuturor masurilor privind protectia datelor cu caracter personal prin colaborarea cu un/numirea unui responsabil protectie date. De asemenea, solicitantul va contracta servicii de audit extern al proiectului, conform cerintelor din ghidul solicitantului.'
            }
        },
        methods: {
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            sendForm(){
                if(this.completed){
                    this.$refs.metodologie.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {metodologie: this.form})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$store.dispatch('finantare/addToProgress', 'Metodologie')
                                    this.$emit('savedData')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Metodologie')
                }
            }

        }
    }
</script>

<style scoped>
.subtitle{
  font-weight: bold;
}
</style>
